














































































































































































































import { Component, Vue } from "vue-property-decorator";
import LoginHeader from "@/components/header/ULoginHeader.vue";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";
import AuthModule from "@/store/auth";

@Component({
  components: {
    Header,
    LoginHeader,
    Footer,
  },
})
export default class Privacy extends Vue {
  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }
}
